<template lang="pug">
  .footer-container
    .column(v-if='overFooter')
      .awards.center.middle.column
        h2.title-small.text-remain.bold.m4-bottom-4.gray
          | {{ $t('footer.awards') }}
        .row.awards-list.middle
          a(href='https://dayonecaixabank.es/dayone-open-innovation-program-conoce-a-las-14-empresas-finalistas/' target='_blank')
            img.award-img.m-right-4(:src='emprendedor' alt='Premio Emprendedor XXI')
          a(href='https://seklab.es/2019/12/06/sek-lab-awards-v-edicion/' target='_blank')
            img.award-img.m-right-4(:src='sekLab' alt='sekLab')
          a(href='https://www.enlighted.education/enlighted-awards' target='_blank')
            img.award-img(:src='enlighted' alt='EnlightED')
          a(href='https://seklab.es/gesawards-spain-finals/' target='_blank')
            img.award-img-big(:src='gesAwards' alt='GESAwards')
      .over-footer
        h2.title-medium.text-remain.white.bold.m4-bottom-4
          | {{ $t('footer.overFooterTitle') }}
        h2.title-big.text-remain.white.bolder.m4-bottom-9
          | {{ $t('footer.itsKimple') }}
        button.primary-button.white-border.contact-button.m-bottom-2(type='button' @click='showElement({ element: "contactModal" })')
          | {{ $t('footer.begin') }}
        .row.space-between.width-100.social-media
          .row
            a(href='https://www.facebook.com/EduKimple-108082410538681/' target='_blank')
              simple-svg.icon.white-icon.m4-right-4(:filepath='facebook' width='25px' height='25px')
            a(href='https://twitter.com/edukimple?lang=es' target='_blank')
              simple-svg.icon.white-icon.m4-right-4(:filepath='twitter' width='25px' height='25px')
            a(href='https://vimeo.com/user92565749' target='_blank')
              simple-svg.icon.white-icon.m4-right-4(:filepath='vimeo' width='25px' height='25px')
            a(href='https://www.instagram.com/edukimple/' target='_blank')
              simple-svg.icon.white-icon.m4-right-4(:filepath='instagram' width='25px' height='25px')
            a(href='https://ar.linkedin.com/company/kimple-education' target='_blank')
              simple-svg.icon.white-icon.m4-right-4(:filepath='linkedin' width='25px' height='25px')
          span.white.bold.text-normal
            | Madrid | Buenos Aires
    .footer.row.middle.center
      p.text-small.footer-text
        | {{ $t('footer.disclaimer', { year }) }}
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

import facebook from '@/assets/ic_facebook.svg'
import twitter from '@/assets/ic_twitter.svg'
import instagram from '@/assets/ic_instagram.svg'
import vimeo from '@/assets/vimeo.svg'
import linkedin from '@/assets/linkedin.svg'
import sekLab from '@/assets/seklab.png'
import emprendedor from '@/assets/premioemprendedor.png'
import enlighted from '@/assets/landing/EnlightED.png'
import gesAwards from '@/assets/landing/GESAwards_SPAIN.png'

export default {
  props: {
    overFooter: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      facebook,
      twitter,
      instagram,
      vimeo,
      sekLab,
      emprendedor,
      enlighted,
      gesAwards,
      linkedin
    }
  },
  computed: {
    year() {
      return moment().year()
    }
  },
  methods: { ...mapActions(['showElement']) }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';

.awards {
  padding: 20px;
  background: $lighter-gray;
}

.award-img {
  height: 50px;
}

.award-img-big {
  height: 65px;
  margin: 0px 30px;
}

.over-footer {
  align-items: center;
  background: url('../assets/landing/bg_footer.svg'), $blue;
  background-repeat: no-repeat;
  background-position: 50% 100%;
  background-size: 71%;
  display: flex;
  flex-direction: column;
  height: 310px;
  justify-content: center;
  width: 100%;
}

.footer {
  height: $footer-height;
  width: 100%;
  background-color: $light-gray;
  align-self: end;
}

.footer-text {
  text-align: center;
}

.social-media {
  max-width: 400px;
}

.contact-button {
  --max-width: 300px;
}

@media screen and (max-width: $laptop-break) {

  .over-footer {
    background-size: 90%;
  }
}

@media screen and (max-width: $mobile-break) {
  .over-footer {
    background: url('../assets/landing/bg_mobile_footer.png'), $blue;
    background-repeat: no-repeat;
    background-size: cover;
    height: 405px;
    padding: 0 30px;
    text-align: center;

    .over-footer-title {
      font-size: 32px;
      line-height: 39px;
    }

    .title-big {
      font-size: 24px;
      line-height: 29px;
      max-width: 300px;
    }
  }

  .awards-list {
    flex-direction: column;
    align-items: center;

    img {
      margin-right: 0;
    }
  }

  .social-media {
    flex-direction: column;
    align-items: center;

    > :last-child {
      margin-top: 20px;
    }
  }
}
</style>
